<template>
    <div class="page-success">
        <div class="column is-multiline">
            <div class="column is-12">


            </div>
        </div>
    </div>

</template>

<script>
export default {
  name: "Success",
  mounted() {
      document.title = 'Success | YNAMLY SHOP'
  },
}
</script>

<style scoped>

</style>